import { useEffect } from "react";
import { animate, motion, useMotionValue, useReducedMotion, useTransform } from "framer-motion";
import { motionTokens } from "@/shared/lib/motion";

/**
 * Nombre qui défile jusqu'à sa valeur (et d'une valeur à l'autre quand elle change).
 * Mouvement réduit : la valeur s'affiche directement.
 */
export function AnimatedNumber({ value, format }: { value: number; format: (value: number) => string }) {
  const reduce = useReducedMotion();
  const current = useMotionValue(reduce ? value : 0);
  const text = useTransform(current, (v) => format(v));

  useEffect(() => {
    if (reduce) {
      current.set(value);
      return;
    }
    const controls = animate(current, value, { duration: motionTokens.duration.crawl, ease: motionTokens.easing.smooth });
    return () => controls.stop();
  }, [value, reduce, current]);

  return <motion.span className="tabular-nums">{text}</motion.span>;
}
